import { KycAndPepWrapper } from "../styles";

import Kyc from "./Kyc";

function PepAndKyc(props) {
  const {
    moneySourcesOptions,
    monthlyTurnovers,
    assets,
    propertySources,
    showCounterPartiesQuestion,
    showKyc,
  } = props;

  return (
    <KycAndPepWrapper>
      {showKyc ? (
        <Kyc
          moneySourcesOptions={moneySourcesOptions}
          monthlyTurnovers={monthlyTurnovers}
          assets={assets}
          propertySources={propertySources}
          showCounterPartiesQuestion={showCounterPartiesQuestion}
        />
      ) : null}
    </KycAndPepWrapper>
  );
}
export default PepAndKyc;
